// Organization service for projects and tags API
import { getAuthHeader } from "./authService";
import { API_BASE_URL } from "../config/api";
import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

const PROJECTS_API = `${API_BASE_URL}/projects`;
const TAGS_API = `${API_BASE_URL}/tags`;
const SONG_ORG_API = `${API_BASE_URL}/song-organization`;

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response
      .json()
      .catch(() => ({ error: "Request failed" }));
    throw new Error(
      error.message ||
        error.error ||
        `Request failed with status ${response.status}`,
    );
  }
  return response.json();
};

// --- Projects ---

export const getProjects = async () => {
  const authHeaders = await getAuthHeader();
  const response = await httpGet(PROJECTS_API, {
    "Content-Type": "application/json",
    ...authHeaders,
  });
  return handleResponse(response);
};

export const createProject = async (name, color) => {
  const authHeaders = await getAuthHeader();
  const response = await httpPost(
    PROJECTS_API,
    { name, color },
    {
      "Content-Type": "application/json",
      ...authHeaders,
    },
  );
  return handleResponse(response);
};

export const updateProject = async (id, data) => {
  const authHeaders = await getAuthHeader();
  const response = await httpPut(`${PROJECTS_API}?id=${id}`, data, {
    "Content-Type": "application/json",
    ...authHeaders,
  });
  return handleResponse(response);
};

export const deleteProject = async (id) => {
  const authHeaders = await getAuthHeader();
  const response = await httpDelete(`${PROJECTS_API}?id=${id}`, {
    "Content-Type": "application/json",
    ...authHeaders,
  });
  return handleResponse(response);
};

// --- Tags ---

export const getTags = async () => {
  const authHeaders = await getAuthHeader();
  const response = await httpGet(TAGS_API, {
    "Content-Type": "application/json",
    ...authHeaders,
  });
  return handleResponse(response);
};

export const createTag = async (name, color) => {
  const authHeaders = await getAuthHeader();
  const response = await httpPost(
    TAGS_API,
    { name, color },
    {
      "Content-Type": "application/json",
      ...authHeaders,
    },
  );
  return handleResponse(response);
};

export const updateTag = async (id, data) => {
  const authHeaders = await getAuthHeader();
  const response = await httpPut(`${TAGS_API}?id=${id}`, data, {
    "Content-Type": "application/json",
    ...authHeaders,
  });
  return handleResponse(response);
};

export const deleteTag = async (id) => {
  const authHeaders = await getAuthHeader();
  const response = await httpDelete(`${TAGS_API}?id=${id}`, {
    "Content-Type": "application/json",
    ...authHeaders,
  });
  return handleResponse(response);
};

// --- Song Organization ---

export const updateSongOrganization = async (songId, { projectId, tagIds }) => {
  const authHeaders = await getAuthHeader();
  const response = await httpPut(
    `${SONG_ORG_API}?songId=${songId}`,
    { projectId, tagIds },
    {
      "Content-Type": "application/json",
      ...authHeaders,
    },
  );
  return handleResponse(response);
};

const organizationService = {
  getProjects,
  createProject,
  updateProject,
  deleteProject,
  getTags,
  createTag,
  updateTag,
  deleteTag,
  updateSongOrganization,
};

export default organizationService;
